module.exports = __webpack_public_path__ + "img/patrocinadores.516a9beb.jpg";